import { Action } from '@ngrx/store';

export enum NegativeCasesActionTypes {
  NoData = '[Negative Cases] No data',
  NoDealOrders = '[Negative Cases] No orders in deal',
  NoFilteredDealOrders = '[Negative Cases] No orders in filtered deal',
  AccountsDisabled = '[Negative Cases] No Data',
  Reset = '[Negative Cases] Reset'
}

export class NoData implements Action {
  public readonly type: string = NegativeCasesActionTypes.NoData;
}

export class NoDealOrders implements Action {
  public readonly type: string = NegativeCasesActionTypes.NoDealOrders;
}

export class NoFilteredDealOrders implements Action {
  public readonly type: string = NegativeCasesActionTypes.NoFilteredDealOrders;
}

export class AccountsDisabled implements Action {
  public readonly type: string = NegativeCasesActionTypes.AccountsDisabled;
}

export class Reset implements Action {
  public readonly type: string = NegativeCasesActionTypes.Reset;
}

export type NegativeCasesActionUnion =
  | NoData
  | NoDealOrders
  | NoFilteredDealOrders
  | AccountsDisabled
  | Reset;
